import { render } from "./KTDatatable.vue?vue&type=template&id=248d0f3f&ts=true"
import script from "./KTDatatable.vue?vue&type=script&lang=ts"
export * from "./KTDatatable.vue?vue&type=script&lang=ts"

import "./KTDatatable.vue?vue&type=style&index=0&id=248d0f3f&lang=scss"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__